import script from "./WageCompareBefore.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageCompareBefore.vue?vue&type=script&setup=true&lang=ts"

import "./WageCompareBefore.vue?vue&type=style&index=0&id=500e325c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500e325c"]])

export default __exports__